"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _v = _interopRequireDefault(require("uuid/v1"));
var _papaparse = _interopRequireDefault(require("papaparse"));
var _flat = _interopRequireDefault(require("flat"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    create: (0, _redux.bindActionCreators)(props.actions.create, dispatch)
  };
};
class BaseTranslate extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      data: [],
      selection: [],
      errors: [],
      messages: [],
      fetching: false,
      fetched: true
    });
    _defineProperty(this, "handleDelete", () => {
      this.setState(prev => {
        return {
          data: prev.data.filter(item => prev.selection.some(s => s !== item.Id)),
          selection: []
        };
      });
    });
    _defineProperty(this, "handleSelect", (bool, id) => {
      if (bool) return this.setState(prev => {
        return {
          selection: [...prev.selection, id]
        };
      });
      return this.setState(prev => {
        return {
          selection: prev.selection.filter(p => p !== id)
        };
      });
    });
    _defineProperty(this, "handleSelectAll", (bool, id) => {
      if (bool) {
        const all = this.state.data.map(item => item.Id);
        return this.setState({
          selection: all
        });
      }
      return this.setState({
        selection: []
      });
    });
    _defineProperty(this, "handleChange", (attr, value, row) => {
      return new Promise((resolve, reject) => {
        this.setState(prev => {
          return {
            data: prev.data.map(item => {
              if (item.Id === row) item[attr] = value;
              return item;
            })
          };
        });
        resolve();
      });
    });
    _defineProperty(this, "handleAdd", (prop, name, join, row) => {
      return new Promise((resolve, reject) => {
        this.setState(prev => {
          return {
            data: prev.data.map(item => {
              if (item.Id === row) item[prop] = [...(item[prop] ? item[prop] : []), {
                [name]: join.Id
              }];
              return item;
            })
          };
        });
        resolve();
      });
    });
    _defineProperty(this, "handleDrop", (prop, name, join, row) => {
      return new Promise((resolve, reject) => {
        this.setState(prev => {
          return {
            data: prev.data.map(item => {
              if (item.Id === row) item[prop] = item[prop].filter(p => p[name] !== join[name]);
              return item;
            })
          };
        });
        resolve();
      });
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      const {
        create,
        [this.props.plural]: store
      } = this.props;
      this.setState({
        fetching: true
      });
      let i = 0;
      const {
        data
      } = this.state;
      const request = () => {
        return create(data[i]).then(response => {
          this.setState(prev => {
            return {
              data: prev.data.filter(p => p.Id !== data[i].Id)
            };
          });
          this.message(`User ${response.Email} created`);
          i++;
          if (i >= data.length) return 'done';
          return request();
        }).catch(err => {
          console.dir(err);
          this.throw(err.Message);
          i++;
          if (i >= data.length) return 'done';
          return request();
        });
      };
      return request();
    });
    _defineProperty(this, "throw", message => {
      this.setState(prev => {
        return {
          errors: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "message", message => {
      this.setState(prev => {
        return {
          messages: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "handleRead", id => {
      this.setState(prev => {
        return {
          errors: prev.errors.filter(error => error.Id !== id),
          messages: prev.messages.filter(message => message.Id !== id)
        };
      });
    });
    _defineProperty(this, "render", () => {
      const {
        children,
        singular,
        entity,
        [this.props.entity.plural]: store,
        actions,
        create,
        ...rest
      } = this.props;
      const {
        errors,
        messages,
        fetching,
        fetched,
        selection,
        data
      } = this.state;
      return _react.default.cloneElement(children, {
        ...rest,
        state: data,
        errors: errors,
        messages: messages,
        fetching: fetching,
        fetched: fetched,
        selection: selection,
        schema: store.import.schema,
        entity,
        fields: (0, _helpers.objectToArray)(store.import.schema),
        onChange: this.handleChange,
        onSelect: this.handleSelect,
        onSelectAll: this.handleSelectAll,
        onSubmit: this.handleSubmit,
        onImport: this.handleImport,
        onDelete: this.handleDelete,
        onRead: this.handleRead,
        onAdd: this.handleAdd,
        onDrop: this.handleDrop
      });
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseTranslate);
module.exports = exports.default;